import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Auth } from "aws-amplify";
import { BaseUserService } from "@smarterplan/ngx-smarterplan-core";
import * as CryptoJS from "crypto-js";

@Component({
    selector: "app-fast-connect",
    templateUrl: "./fast-connect.component.html",
    styleUrls: ["./fast-connect.component.scss"],
})
export class FastConnectComponent implements OnInit {
    spaceID: string;

    model3D: string;

    encryptedUser: string;

    errorMessage: string;

    isLoading = true;

    constructor(
        private router: Router,
        private userService: BaseUserService,
        private activatedRoute: ActivatedRoute,
    ) {
        /** /redirect?user=encyptedInfo&spaceID=id&model3D=model */
        this.activatedRoute.queryParams.subscribe((parameters) => {
            this.encryptedUser = parameters.user ? parameters.user : null;
            this.spaceID = parameters.spaceID ? parameters.spaceID : null;
            this.model3D = parameters.model3D ? parameters.model3D : null;
        });
    }

    ngOnInit(): void {
        // http://localhost:4200/redirect?spaceID=ee2a8282-b8bf-493c-a827-a2e4179ed135&model3D=BW5m1xgGfBd&user=U2FsdGVkX1%20RaHJBVPD%20sjnKy7eMkugg%20c3eghtkTsbIw3ggGk9Fk111WKYoEbZwnEQgYxtTXnomeHRUTQctHrVGiSl4sfINzG3gtYalWxdV2yX8iHDifQ0Uoq%203Mta4
        if (!this.spaceID || !this.model3D) {
            this.errorMessage = "3D visit is not available.";
            this.isLoading = false;
        }

        if (this.encryptedUser) {
            const convertedUser = decodeURIComponent(
                this.encryptedUser.replace(/ /g, "+"), // replace all spaces with "+"
            );
            let decrypted;
            try {
                const bytes = CryptoJS.AES.decrypt(
                    convertedUser,
                    "EncryptedUser",
                );
                decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            } catch (error) {
                console.log(`Decrypting error :${error}`);
                this.isLoading = false;
                this.errorMessage = "Error while connecting to the 3D visit";
                return;
            }

            // console.log(decrypted);
            if (decrypted && decrypted.user && decrypted.password) {
                Auth.signIn(decrypted.user, decrypted.password)
                    .then((user) => {
                        this.userService.current(user, true).then(() => {
                            if (this.userService.cu) {
                                this.isLoading = false;
                                this.router.navigate(["museum", this.spaceID]);
                            }
                        });
                    })
                    .catch((error) => {
                        console.log(`AWS error:${error.code}`);
                        this.isLoading = false;
                        this.errorMessage =
                            "Error while connecting to the 3D visit";
                    });
            }
        } else {
            this.isLoading = false;
            this.errorMessage = "Error while connecting to the 3D visit";
        }
    }
}
